import * as yup from "yup";

function validateCPF(cpf) {
  cpf = cpf.replace(/\D/g, "");
  if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  let result = true;
  [9, 10].forEach(function (j) {
    let soma = 0,
      r;
    cpf
      .split(/(?=)/)
      .splice(0, j)
      .forEach(function (e, i) {
        soma += parseInt(e) * (j + 2 - (i + 1));
      });
    r = soma % 11;
    r = r < 2 ? 0 : 11 - r;
    if (r != cpf.substring(j, j + 1)) result = false;
  });
  return result;
}

const schema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Minimum 3 characters")
    .max(50, "Maximum 50 characters")
    .required("Name is required"),
  cpf: yup
    .string()
    .required("CPF is required")
    .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, "Invalid CPF")
    .test("is-valid-cpf", "Invalid CPF", (cpf) => validateCPF(cpf)),
  skill: yup.string().uuid().required("Skill is required").nullable(),
});

export default schema;
